import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const LegalPageLayout = ({ title, lastUpdated, children }) => {
    return (
        <Layout>
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Back Button */}
                <Link to="/">
                    <Button variant="ghost" size="sm" className="mb-6 -ml-2">
                        <ArrowLeft className="h-4 w-4 mr-1" />
                        Back to Home
                    </Button>
                </Link>

                {/* Header */}
                <div className="mb-8">
                    <h1 className="font-heading font-bold text-3xl sm:text-4xl text-foreground">
                        {title}
                    </h1>
                    {lastUpdated && (
                        <p className="text-sm text-muted-foreground mt-2">
                            Last Updated: {lastUpdated}
                        </p>
                    )}
                </div>

                {/* Content */}
                <div className="legal-content prose prose-slate dark:prose-invert max-w-none">
                    {children}
                </div>
            </div>
        </Layout>
    );
};

// Reusable section components
export const Section = ({ title, children }) => (
    <section className="mb-10">
        <h2 className="font-heading font-semibold text-xl text-foreground mb-4 pb-2 border-b border-border">
            {title}
        </h2>
        <div className="space-y-4 text-muted-foreground">
            {children}
        </div>
    </section>
);

export const Paragraph = ({ children }) => (
    <p className="text-sm leading-relaxed text-muted-foreground">
        {children}
    </p>
);

export const List = ({ items }) => (
    <ul className="list-disc list-inside space-y-2 text-sm text-muted-foreground ml-2">
        {items.map((item, index) => (
            <li key={index}>{item}</li>
        ))}
    </ul>
);

export const Highlight = ({ children }) => (
    <div className="p-4 bg-card border border-border rounded-lg my-4">
        <p className="text-sm text-foreground">{children}</p>
    </div>
);

export const Example = ({ allowed, text }) => (
    <div className={`p-3 rounded-lg my-2 text-sm ${
        allowed 
            ? 'bg-emerald-500/10 border border-emerald-500/30 text-emerald-600 dark:text-emerald-400' 
            : 'bg-red-500/10 border border-red-500/30 text-red-600 dark:text-red-400'
    }`}>
        <span className="font-medium">{allowed ? '✓ Allowed:' : '✗ Prohibited:'}</span> "{text}"
    </div>
);

export default LegalPageLayout;
